var _linearGradient, _linearGradient2, _circle, _linearGradient3, _path, _linearGradient4, _path2, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 20 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 1278.795,
    y1: -959.464,
    x2: 1279.795,
    y2: -959.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 43.489,
    y1: 100.199,
    x2: 154.909,
    y2: 100.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.199,
    cy: 100.199,
    r: 54.46,
    fill: "none",
    stroke: "url(#SVGID_1_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 35.526,
    y1: 100.199,
    x2: 162.872,
    y2: 100.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.084 60.151c9.075 10.839 14.538 24.806 14.538 40.048 0 34.475-27.948 62.423-62.423 62.423s-62.423-27.948-62.423-62.423 27.948-62.423 62.423-62.423c10.293 0 20.005 2.491 28.564 6.904",
    fill: "none",
    stroke: "url(#SVGID_2_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 126.513,
    y1: 52.415,
    x2: 148.334,
    y2: 52.415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.763 44.679a62.669 62.669 0 0119.321 15.471",
    fill: "none",
    stroke: "url(#SVGID_3_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98.984 100.186l47.639-40.07M127.613 44.97l-28.858 55.071M99.199 100.199h61.943M119.887 158.516l-21.085-58.244"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 7787.016,
    y1: -391.766,
    x2: 7801.938,
    y2: -391.766,
    gradientTransform: "translate(-7717.946 491.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.364 94.992s-1.04-6.141-5.992-6.137-6.276 6.148-6.276 6.148l12.868 9.992",
    fill: "none",
    stroke: "url(#SVGID_4_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 7787.016,
    y1: -391.766,
    x2: 7801.938,
    y2: -391.766,
    gradientTransform: "translate(-7717.946 491.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.697 105.007s1.04 6.141 5.992 6.137c4.951-.005 6.276-6.148 6.276-6.148",
    fill: "none",
    stroke: "url(#SVGID_5_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 7787.016,
    y1: -391.766,
    x2: 7801.938,
    y2: -391.766,
    gradientTransform: "translate(-7717.946 491.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M76.516 83.622l.005 5.233"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0",
    gradientUnits: "userSpaceOnUse",
    x1: 7787.016,
    y1: -391.766,
    x2: 7801.938,
    y2: -391.766,
    gradientTransform: "translate(-7717.946 491.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_6ced66398025e78648948ce357bb4c84587b616950b858bd6b44a0da6c1ac5c0)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M76.541 111.144l.004 5.232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryComponents);
export default __webpack_public_path__ + "static/media/salaryComponents.2e12c027cb6ae9df26a5cd8184789154.svg";
export { ForwardRef as ReactComponent };